import * as materials from "@lts/materials/legacy/legacy-water";
export { materials };
export default materials;
